export default __webpack_public_path__ + "static/media/img5.7ca31843.jpg";